var waitFor = require("../utils/waitFor");

waitFor(".sales-locate__form", function () {
  require("chosen-js");

  var $geolocateMe = $(".geolocate-me"),
    $searchForm = $(".sales-locate__form"),
    $inputCountry = $(".sales-locate-country"),
    $inputZip = $(".sales-locate-zip"),
    $hrOr = $(".sales-locate-or"),
    $zipWrap = $(".sales-locate-zip-wrap"),
    $yourLoc = $(".sales-locate__your-location"),
    $yourLocCountry = $(".location-name.location-country"),
    $yourLocZip = $(".location-name.location-zip"),
    $aboveFoldResults = $(".sales-locate__above_fold"),
    $belowFoldResults = $(".sales-locate__below_fold"),
    $showBelowFold = $(".show-below-fold"),
    $agentsWrap = $(".sales-locate__agents-wrap"),
    $editLocation = $yourLoc.find(".edit-location"),
    $noResults = $(".sales-locate__no-results"),
    $loadingAgents = $(".sales-locate_loading.agent"),
    $loadingLocation = $(".sales-locate_loading.location");

  // enable auto location if browser feature exists
  if ("geolocation" in navigator) {
    $geolocateMe.show();
  }

  function cantGeolocate(msg) {
    if (!msg) msg = "Unable to find your location. Please enter it manually.";

    $geolocateMe.hide();
    $loadingLocation.hide();
    $hrOr.hide();

    return alert(msg);
  }

  function getLatLong() {
    $loadingLocation.show();

    navigator.geolocation.getCurrentPosition(
      function (position) {
        getCountryStateZipFromLatLong(
          position.coords.latitude,
          position.coords.longitude
        );
      },
      function (err) {
        cantGeolocate();
      }
    );
  }

  function getCountryStateZipFromLatLong(lat, long) {
    if (!window.isGmapsReadySales)
      return window.queuedGmapsCallbacksSales.push(function () {
        getCountryStateZipFromLatLong(lat, long);
      });

    var latLng = new google.maps.LatLng(lat, long),
      geocoder = new google.maps.Geocoder();

    // get country and zip
    geocoder.geocode({ location: latLng }, function (results, status) {
      var countryCode, countryFull, state, zip;

      if (status !== "OK" || results.length == 0) {
        cantGeolocate();
      }

      // parse results for country and zip
      $.each(results[0].address_components, function (i, el) {
        if (el.types.indexOf("country") > -1) {
          countryCode = el.short_name;
          countryFull = el.name;
        }

        if (el.types.indexOf("state") > -1) state = el.short_name;

        if (el.types.indexOf("postal_code") > -1) zip = el.short_name;
      });

      if (!countryCode || !zip) return cantGeolocate();

      // update cur loc info
      $yourLocCountry.text(countryFull);
      $yourLocZip.text(zip);

      $loadingLocation.hide();

      // get agents
      querySalesAgents(countryCode, state, zip, function () {
        // update form inputs
        $inputCountry.val(countryCode).trigger("chosen:updated");

        $inputZip.val(zip);
      });
    });
  }

  var agentQueryXHR = false;
  function querySalesAgents(country, state, zip, callback) {
    $loadingAgents.show();

    agentQueryXHR = $.ajax({
      url: window.SITE_SETTINGS.blogurl,
      data: {
        country: country,
        state: state,
        zip: zip,
        is_sales_agent_search: 1,
      },
      dataType: "json",
      cache: true,
      success: function (results) {
        displaySalesAgents(results);

        if (callback) callback();
      },
      complete: function () {
        $loadingAgents.hide();
        agentQueryXHR = false;
      },
    });
  }

  function renderAgent(agent) {
    var html = "",
      contactInfo = [];

    if (agent.address && agent.address.length > 0)
      contactInfo.push(agent.address);

    if (agent.phone && agent.phone.length > 0)
      contactInfo.push("Office: " + agent.phone);

    if (agent.mobile && agent.mobile.length > 0)
      contactInfo.push("Mobile: " + agent.mobile);

    if (agent.email && agent.email.length > 0)
      contactInfo.push('<a href="mailto:' + agent.email + '">Email</a>');

    html =
      '<div class="sales-locate__agent-info">' +
      '<h4 class="agent-name">' +
      agent.name +
      "</h4>" +
      (agent.label ? '<h5 class="agent-title">' + agent.label + "</h5>" : "") +
      '<h5 class="agent-title">' +
      agent.type +
      "</h5>" +
      '<p class="contact-info">' +
      contactInfo.join("<br>") +
      "</p>" +
      "</div>";

    return html;
  }

  function displaySalesAgents(agentData) {
    var agentsByType = {
        "Territory Manager": [],
        "Regional Manager": [],
        Distributor: [],
        "Rep Firm": [],
        "Field Application Engineer": [],
        "Business Development Manager": [],
      },
      aboveFold = [],
      belowFold = [],
      hasExclusive = [];

    if (!window.isFullSalesPage) {
      $searchForm.hide();
      $yourLoc.show();
    }

    $noResults.hide();
    $showBelowFold.hide();
    $belowFoldResults.hide();

    // organize agent data
    var agentCount = 0;
    $.each(agentData, function (ind, agent) {
      agentCount++;
      if (agent.exclusive_to_territory) return hasExclusive.push(agent);

      agentsByType[agent.type].push(agent);
    });

    if (agentCount == 0) $noResults.show();

    // sort within each
    function _sortByTitle(a, b) {
      if (a.name > b.name) return 1;
      return -1;
    }

    function _sortBySurname(a, b) {
      if (a.surname > b.surname) return 1;
      return -1;
    }

    $.each(agentsByType, function (type, agents) {
      if (type == "Territory Manager" || type == "Regional Manager")
        agentsByType[type].sort(_sortBySurname);
      else agentsByType[type].sort(_sortByTitle);
    });
    hasExclusive.sort(_sortByTitle);

    // sort into folds

    if (
      agentsByType["Field Application Engineer"].length > 0 ||
      agentsByType["Business Development Manager"].length > 0
    ) {
      aboveFold = aboveFold.concat(
        agentsByType["Business Development Manager"],
        agentsByType["Field Application Engineer"]
      );
    } else if (agentsByType["Territory Manager"].length > 0) {
      aboveFold = aboveFold.concat(agentsByType["Territory Manager"]);
    } else if (agentsByType["Regional Manager"].length > 0) {
      aboveFold = aboveFold.concat(agentsByType["Regional Manager"]);
    }

    // exclusive distributors go above the fold
    if (hasExclusive.length > 0) {
      aboveFold = aboveFold.concat(hasExclusive);
    }

    // remaining distributors go below
    belowFold = belowFold.concat(
      agentsByType["Distributor"],
      agentsByType["Rep Firm"]
    );

    // render it
    var aboveHtml = "";
    $.each(aboveFold, function (i, agent) {
      aboveHtml += renderAgent(agent);
    });
    $aboveFoldResults.html(aboveHtml);

    if (belowFold.length > 0) {
      var belowHtml = "";
      $.each(belowFold, function (i, agent) {
        belowHtml += renderAgent(agent);
      });
      $belowFoldResults.html(belowHtml);

      $showBelowFold.show();
    }

    $agentsWrap.show();
  }

  $editLocation.click(function (e) {
    e.preventDefault();

    $searchForm.show();
    $yourLoc.hide();
    $noResults.hide();
    $agentsWrap.hide();
  });

  // clear out zip value when they change country. this is bound in the dom element attrs
  window.findSalesAgentCountryChange = function (e) {
    $inputZip.val("");

    if ($inputCountry.children(":selected").data("just-country")) {
      $zipWrap.hide();

      querySalesAgents($inputCountry.val(), "", "", function () {
        // update cur loc info
        $yourLocCountry.text($inputCountry.children(":selected").text());
        $yourLocZip.text("");
      });
    } else {
      $zipWrap.show();
    }
  };

  var zipKeyupTO;
  $inputZip.on("keyup", function (e) {
    var zipVal = $inputZip.val();

    clearTimeout(zipKeyupTO);

    if (agentQueryXHR !== false) agentQueryXHR.abort();

    if (zipVal.length < 5 || e.which == 8) {
      // esc
      return;
    }

    zipKeyupTO = setTimeout(function () {
      querySalesAgents($inputCountry.val(), "", zipVal);

      // update cur loc info
      $yourLocCountry.text($inputCountry.children(":selected").text());
      $yourLocZip.text(zipVal);
    }, 700);
  });

  $showBelowFold.on("click", function (e) {
    $showBelowFold.hide();
    $belowFoldResults.show();
  });

  $geolocateMe.on("click", function (e) {
    e.preventDefault();
    getLatLong();
  });

  $inputCountry.chosen().on("change", findSalesAgentCountryChange);
});
